var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Button',{attrs:{"color":"shade-white","to":_vm.addDomainPath}},[_c('Icon',{attrs:{"color":"primary","left":"","icon":"$arrows-cycle-check-outline","iconSize":"small"}}),_c('span',{staticClass:"primary--text",domProps:{"textContent":_vm._s(_vm.lc.label)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }